import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/department')({
    component: Outlet,
    staticData: {
        crumb: {
            label: `My Department`
        }
    }
})
